import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useMetaPixel } from '../../hooks/useMetaPixel';
export function Hero() {
  const {
    trackAddToCart
  } = useMetaPixel();
  const checkoutUrl = 'https://krove.lat//cart/40641678344321:1';
  const handleBuy = () => {
    trackAddToCart();
    window.location.href = checkoutUrl;
  };
  return <section className="relative overflow-hidden bg-stone-50 pt-12 pb-16 md:pt-20 md:pb-24" data-id="element-65">
      <div className="container mx-auto px-4" data-id="element-66">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center" data-id="element-67">
          {/* Content */}
          <div className="max-w-2xl mx-auto lg:mx-0 text-center lg:text-left" data-id="element-68">
            <div className="inline-flex items-center rounded-full bg-emerald-100 px-3 py-1 text-sm font-medium text-emerald-800 mb-6" data-id="element-69">
              <span className="flex h-2 w-2 rounded-full bg-emerald-600 mr-2" data-id="element-70"></span>
              Método de 21 Días
            </div>

            <h1 className="text-4xl font-bold tracking-tight text-stone-900 sm:text-5xl md:text-6xl mb-6 leading-tight" data-id="element-71">
              No estás subiendo de peso:{' '}
              <span className="text-emerald-700" data-id="element-72">estás inflamada.</span>
            </h1>

            <p className="text-xl text-stone-600 mb-8 leading-relaxed" data-id="element-73">
              21 días para bajar hinchazón (sin vivir a dieta) con un sistema
              simple y repetible.
            </p>

            <ul className="space-y-4 mb-10 text-left max-w-md mx-auto lg:mx-0" data-id="element-74">
              <li className="flex items-start" data-id="element-75">
                <CheckIcon className="h-6 w-6 text-emerald-600 mr-3 flex-shrink-0" data-id="element-76" />
                <span className="text-stone-700" data-id="element-77">
                  Reduce la hinchazón y retención de líquidos
                </span>
              </li>
              <li className="flex items-start" data-id="element-78">
                <CheckIcon className="h-6 w-6 text-emerald-600 mr-3 flex-shrink-0" data-id="element-79" />
                <span className="text-stone-700" data-id="element-80">
                  Siente tu abdomen menos tenso y más ligero
                </span>
              </li>
              <li className="flex items-start" data-id="element-81">
                <CheckIcon className="h-6 w-6 text-emerald-600 mr-3 flex-shrink-0" data-id="element-82" />
                <span className="text-stone-700" data-id="element-83">
                  Crea la base para perder peso sin extremos
                </span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start mb-6" data-id="element-84">
              <Button size="xl" onClick={handleBuy} className="w-full sm:w-auto shadow-emerald-200" data-id="element-85">
                Quiero desinflamarme en 21 días
              </Button>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 text-sm text-stone-500 mb-8" data-id="element-86">
              <span className="flex items-center" data-id="element-87">
                <ZapIcon className="h-4 w-4 mr-1.5" data-id="element-88" />
                Acceso inmediato
              </span>
              <span className="flex items-center" data-id="element-89">
                <ShieldCheckIcon className="h-4 w-4 mr-1.5" data-id="element-90" />
                Pago seguro
              </span>
              <span className="flex items-center" data-id="element-91">
                <LockIcon className="h-4 w-4 mr-1.5" data-id="element-92" />
                100% Digital
              </span>
            </div>

            <div className="text-center lg:text-left" data-id="element-93">
              <p className="text-2xl font-bold text-stone-900" data-id="element-94">23.999 COP</p>
              <p className="text-xs text-stone-400 mt-2" data-id="element-95">
                No es medicina. Es un sistema de hábitos y comidas simples.
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="relative mx-auto w-full max-w-[500px] lg:max-w-none" data-id="element-96">
            <div className="relative rounded-3xl bg-white p-4 shadow-2xl ring-1 ring-stone-900/10" data-id="element-97">
              <img src="https://cdn.magicpatterns.com/uploads/qCtF3Cgy4B3QKXLxo7rmxk/21_DIAS_DESINFLAMA.png" alt="Desinflama Primero Ebook en iPad" className="w-full rounded-2xl" data-id="element-98" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-12 -right-12 -z-10 h-[300px] w-[300px] rounded-full bg-emerald-100/50 blur-3xl" data-id="element-99"></div>
            <div className="absolute -bottom-12 -left-12 -z-10 h-[300px] w-[300px] rounded-full bg-amber-100/50 blur-3xl" data-id="element-100"></div>
          </div>
        </div>
      </div>
    </section>;
}